var map = {
	"./Color-Icon.svg": "oZeG",
	"./Icon-Due-Dates-Green.svg": "ZmFn",
	"./Icon-Filter-Green.svg": "oHqX",
	"./Icon-Integrations.svg": "X1bM",
	"./Icon-Resource-Management.svg": "psNG",
	"./Icon-Split-View-Red.svg": "sewf",
	"./icon-add-subscribers-blue.svg": "whTp",
	"./icon-archive-projects-green.svg": "YqsG",
	"./icon-assignees-blue.svg": "9Eqa",
	"./icon-blue-checkmark.svg": "vLVr",
	"./icon-create-tasks-blue.svg": "xghD",
	"./icon-drag-drop-red.svg": "Pdgl",
	"./icon-due-dates-blue.svg": "CkuQ",
	"./icon-duplicate-projects-green.svg": "n4Wj",
	"./icon-file-uploads-blue.svg": "2LrU",
	"./icon-filters-red.svg": "Jt5c",
	"./icon-green-checkmark.svg": "PUS3",
	"./icon-multiple-teams-green.svg": "95Xz",
	"./icon-notifications-green.svg": "4RlW",
	"./icon-project-export-green.svg": "f6V/",
	"./icon-project-filters-green.svg": "kR5O",
	"./icon-project-notes-green.svg": "6W02",
	"./icon-project-sections-green.svg": "J12Q",
	"./icon-public-projects-green.svg": "TIOi",
	"./icon-recurring-tasks-blue.svg": "5k4a",
	"./icon-recurring-tasks-green.svg": "oZW5",
	"./icon-tags-flags-blue.svg": "jrLG",
	"./icon-task-comments-blue.svg": "hGHi",
	"./icon-task-notes-blue.svg": "HqZ4",
	"./icon-task-tracking.svg": "HpFm",
	"./icon-team-workload-red.svg": "DL//",
	"./icon-user-permissions-green.svg": "sQqR",
	"./icon-workgroups-red.svg": "7Rlh",
	"./icon-workload-groups.svg": "smaM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mtBb";